<template>
  <UikitFormNumberPicker
    :model-value="(productCount ?? 1)"
    :name="name"
    :label="label"
    :min="1"
    :max="countSizes"
    :small="small"
    :loading="loading"
    :disabled="!canChangeAmount"
    :postfix="$t('components.product.productAmountPicker.unit')"
    @update:model-value="emits('update', $event)"
  />
</template>

<script setup lang="ts">
import { OrderPositionDTORes } from '~/restAPI/data-contracts';

const props = defineProps<{
  name: string
  product?: OrderPositionDTORes
  small?: boolean
  loading?: boolean
  label?: string
}>();

const emits = defineEmits<{
  (e: 'update', value: number): void,
}>();

const countSizes = computed(() => {
  if (props.product?.count) {
    return props.product.sizes?.find((s) => s.id === props.product?.size?.id)?.count ?? 0;
  }

  return 0;
});

const canChangeAmount = computed(() => props.product?.sizes && countSizes.value > 1);

const productCount = computed(() => {
  const count = props.product?.count;

  if (countSizes.value && count) {
    return (count > countSizes.value) ? countSizes.value : count;
  }
  return props.product?.count;
});
</script>
